<template>
	<div class='deals-search'>
		<c-select2
			v-model='search'
			:options='params.search_by.items'
			:label='params.search_by.label'
			@change='changeHandle'
			@input='changeSearchBySelectHandle'
		/>
		<div class='search'>
			<div class='search__field'>
				<input class='search__field-input'
					type='search'
					v-model='str'
					placeholder='Search'
					@focus='visible = true'
					@blur='blurHandle()'
					@input='changeQuery()'
					@keyup.enter='changeHandle'
				>
				<icon icon-name='search' @click='changeHandle'/>
				<!-- <button class='search__field-send waves-effect btn'
					:disabled='str === ""'
					@click='changeHandle'
				>
					<icon icon-name='arrow' />
				</button> -->
				<transition >
					<ul class='search__list' v-show='items && items.length > 0 && visible' >
						<li
							class='search__item'
							v-for='(item, index) in items'
							:key='index'
							@click='selectAutocomplete(item)'
						>
							<div class='search__link link'
								:class='{"is-active": index === count}'
							>{{ item.label }}</div>
						</li>
					</ul>
				</transition>
			</div>
		</div>
		<a class='btn btn--white btn--all waves-effect' v-if='showAll' href='/deals/'>All</a>
		<c-select2
			v-model='order'
			:options='params.order_by.items'
			:label='params.order_by.label'
			@change='changeHandle'
		/>
		<!-- <selected :list='params.order_by' @onActive='setOrderBy' /> -->
	</div>
</template>

<script>
import icon from '__jsVueUI/icon.vue';
import cSelect2 from '__jsVueUI/c-select2/c-select2.vue';
import changeHandleTimeout from '__jsVueMixin/changeHandleTimeout';
import api from '__jsVueApi';
import global from '__jsVueMixin/global';

let i = 0;

export default {
	name:   'DealsSearch',
	mixins: [changeHandleTimeout, global],
	props:  [
		'header', 'params', 'routeName'
	],

	components: {
		icon,
		'c-select2': cSelect2
	},
	mounted() {
		this.setDefaultValues();
		if (this.str) {
			this.autocomplete();
		}
	},
	data() {
		return {
			visible: false,
			count:   -1,
			items:   [],
			href:    null
		};
	},
	computed: {
		showAll() {
			return this.str !== '';
		},
		str: {
			get() {
				return this.$store.state.deals.search.str;
			},
			set(newVal) {
				this.dynamichref = this.changeParam('query', newVal);
				this.$store.commit('deals/setSearchStr', newVal);
			}
		},
		major_market: {
			get() {
				return this.$store.state.deals.search.major_market;
			},
			set(newVal) {
				this.dynamichref = this.changeParam('market', newVal);
				this.$store.commit('deals/setSearchMajor_market', newVal);
			}
		},
		search: {
			get() {
				return this.$store.state.deals.search.search;
			},
			set(newVal) {
				this.dynamichref = this.changeParam('search', newVal);
				this.$store.commit('deals/setSearchSearch', newVal);
			}
		},
		order: {
			get() {
				return this.$store.state.deals.search.order;
			},
			set(newVal) {
				this.dynamichref = this.changeParam('order', newVal);
				this.$store.commit('deals/setSearchOrder', newVal);
			}
		},
		char() {
			return (this.routeName.indexOf('?') > -1) ? ('&') : ('?');
		},
		url() {
			return 'dd';
		},
	},
	methods: {
		changeSearchBySelectHandle() {
			this.str = '';
			this.items = [];
		},
		blurHandle() {
			setTimeout(() => {
				this.visible = false;
			}, 200);
		},
		async autocomplete() {
			if (this.search === 'market') {
				// await axios.get(api.choices.cities, {
				let params = {
					q:         this.str,
					page_size: 5,
					search_by: 'market'
				};
				if (this.routeName === '/success-stories/') {
					params.status = 'closed';
				}
				if (this.routeName === '/deals/') {
					params.is_public = true;
				}
				await axios.get(api.publicDeals.autocomplete, {
					params: params
				}).then((response) => {
					this.items = response.data.data.map((el) => {
						return {
							label: el[1],
							value: el[0],
						};
					});
				}).catch(err => {
					this.$store.commit('main/setLoad', false);
					throw new Error(err);
				});
			}
			else {
				let params = {
					search_by: this.search,
					q:         this.str,
				};
				if (this.routeName === '/success-stories/') {
					params.status = 'closed';
				}
				if (this.routeName === '/deals/') {
					params.is_public = true;
				}
				await axios.get(api.publicDeals.autocomplete, {
					params
				})
					.then(response => {
						this.items = response.data.data.map((el) => {
							return {
								label: el,
								value: false,
							};
						});
					})
					.catch(err => {
						this.$store.commit('main/setLoad', false);
						throw new Error(err);
					});
			}
		},
		changeQuery() {
			if (this.str === '') {
				this.str = '';
				this.major_market = '';
			}
			this.autocomplete();
			if (this.search !== 'market' || this.str === '') {
				this.changeHandleTimeout(1000);
			}
		},
		selectAutocomplete(item) {
			this.str = item.label;
			this.major_market = item.value;
			if (this.search === 'market') {
				this.$emit('change');
			}
			else {
				this.changeHandle();
			}
		},
		async changeHandle() {
			this.clearChangeHandleTimeout();
			this.dynamichref = this.changeParam('page', 1);
			this.$emit('change');
		},
		changeHandleTimeout(timeout) {
			this.changeHandleTimeoutHandle(timeout, async() => {
				this.changeHandle();
			});
		},
		setDefaultValues() {
			for (const key in this.params.order_by.items) {
				const element = this.params.order_by.items[key];
				if (element.active) {
					if (this.paramsUrlObj.order) {
						this.$store.commit('deals/setSearchOrder', this.paramsUrlObj.order);
					}
					else {
						this.$store.commit('deals/setSearchOrder', element.value);
					}
				}
			}
			for (const key in this.params.search_by.items) {
				const element = this.params.search_by.items[key];
				if (element.active) {
					if (this.paramsUrlObj.search) {
						this.$store.commit('deals/setSearchSearch', this.paramsUrlObj.search);
					}
					else {
						this.$store.commit('deals/setSearchSearch', element.value);
					}
				}
			}
			if (this.paramsUrlObj.query) {
				this.str = this.paramsUrlObj.query;
			}
			if (this.paramsUrlObj.market) {
				this.major_market = this.paramsUrlObj.market;
			}
		}
	},
};
</script>
